<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <div class="lg:max-w-detaillg lg:mr-auto">
          <localization language="es-ES">
            <intl locale="es">

              <div class="flex p-1 items-center justify-center mr-4">
                <div class="flex p-1 items-center justify-center">
                  <base-button-icon 
                    v-if="isMoreLowerYear" 
                    @click="modifyYear(false)" 
                    name="chevronleft" 
                    title="Año anterior"
                    size="xs" 
                    mode="primary-phantom" 
                    :disabled="!totalDaysSelected || totalDaysSelected.length > 0"
                    ariaLabel="Cambiar al año anterior"
                    />
                  <div v-else class="w-8"></div>
                  <div class="pl-2 pr-2 dark:text-darkblue-200">Año {{form.year}}</div>
                  <base-button-icon 
                    v-if="(actualYear + 1) > form.year" 
                    @click="modifyYear(true)" 
                    title="Año siguiente"
                    name="chevronright" 
                    size="xs"
                    mode="primary-phantom" 
                    :disabled="!totalDaysSelected || totalDaysSelected.length > 0"
                    ariaLabel="Cambiar al año siguiente"
                    />
                  <div v-else class="w-8"></div>
                </div>
              </div>

              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row mb-6">
                <div class="px-2 w-full mb-2 lg:mb-0 ">
                  <base-ro-input :label="$t('courtesy_days_aeat.consulta.date_last_ok')" :data="this.formatDate(selectedDateConsultaOK)+''"/>
                </div>
                <div v-if="selectedStatusConsulta !== 3" class="px-2 w-full mb-2 lg:mb-0 flex ">
                  <base-ro-input class="mr-4 w-full" :label="$t('courtesy_days_aeat.consulta.status_is_last_ko')" :data="statusLabelConsulta"/>
                </div>
                <div 
                  v-if="(selectedStatusConsulta === 5) && !isLowerThanActualYear"
                  class="flex items-center"
                  >
                  <base-button 
                    mode="secondary" 
                    class="w-full lg:w-[6.5rem]"
                    size="xs"
                    :text="$t('app.cancel')" 
                    @click="cancelConsultaVacaciones()" 
                    :loading="isGeneralLoading" 
                    :disabled="isGeneralLoading"/>
                </div>
                <div v-else class="w-56"></div>
              </div>
              
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row mb-6">
                <div class="px-2 w-full mb-2 lg:mb-0">
                  <base-ro-input :label="$t('courtesy_days_aeat.solicitud.date_last_ok')" :data="this.formatDate(selectedDateSolicitudOK)"/>
                </div>
                <div v-if="selectedStatusSolicitud !== 3" class="px-2 w-full mb-2 lg:mb-0 flex">
                  <base-ro-input class="mr-4 w-full" :label="$t('courtesy_days_aeat.solicitud.status_is_last_ko')" :data="statusLabelSolicitud"/>
                </div>
                <div v-if="(selectedStatusSolicitud === 5) && !isLowerThanActualYear">
                  <base-button 
                    mode="primary" 
                    class="w-full mb-1"
                    v-if="selectedStatusConsulta !== 0"
                    size="xs"
                    :text="$t('app.retry')" 
                    @click="validatorSendVacaciones(true)" 
                    :loading="isGeneralLoading" 
                    :disabled="isGeneralLoading"/>
                  <base-button 
                    mode="secondary" 
                    class="w-full"
                    size="xs"
                    :text="$t('app.cancel')" 
                    @click="cancelVacaciones()" 
                    :loading="isGeneralLoading" 
                    :disabled="isGeneralLoading"/>
                </div>
                <div v-else class="w-56"></div>
              </div>

              <ul class="lg:mb-4 w-full flex -mx-2 flex-col lg:flex-row">
                <li class="px-2 mb-2 lg:mb-0 flex">
                  <base-ro-input-minimal :label="$t('courtesy_days_aeat.days_total') + ': ' + selectedTotalDays"/>
                </li>
                <li class="px-2 mb-2 lg:mb-0 flex">
                  <base-ro-input-minimal :label="$t('courtesy_days_aeat.days_pendientes') + ': ' + selectedPendingDays" />
                </li>
                <li class="px-2 mb-2 lg:mb-0 flex">
                  <base-ro-input-minimal :label="$t('courtesy_days_aeat.days_solicitados') + ': ' + selectedSolicitDays" />
                  <div class=" ml-2 h-5 w-5 bg-primary-800 border border-solid border-darkblue-600 rounded-full" />
                </li>
                <li class="px-2 mb-2 lg:mb-0 flex">
                  <base-ro-input-minimal :label="$t('courtesy_days_aeat.days_solicitados_pendientes') + ': ' + selectedSolicitPending" />
                  <div class=" ml-2 h-5 w-5 bg-secondary-600 border border-solid border-darkblue-600 "/>
                </li>
              </ul>

              <div class="vld-parent">
                <loading :opacity="darkMode ? 0 : 0.5" :active="false || isPendingAction" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
                <div v-if="!loadingCalendar"  class="flex flex-wrap">
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Enero</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 1"
                      ref="calendar1"
                      @change="onChangeCalendar1"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month1"
                      :navigation="false"
                      :min="new Date(form.year, 0, lastEnableMonth === 1 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 0, 31)"
                      />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Febrero</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 2"
                      ref="calendar2"
                      @change="onChangeCalendar2"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month2"
                      :navigation="false"
                      :min="new Date(form.year, 1, lastEnableMonth === 2 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 1, esBisiestoActual ? 29 : 28)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Marzo</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 3"
                      ref="calendar3"
                      @change="onChangeCalendar3"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month3"
                      :navigation="false"
                      :min="new Date(form.year, 2, lastEnableMonth === 3 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 2, 31)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Abril</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 4"
                      ref="calendar4"
                      @change="onChangeCalendar4"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month4"
                      :navigation="false"
                      :min="new Date(form.year, 3, lastEnableMonth === 4 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 3, 30)"
                    />
                  </div>
                
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Mayo</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 5"
                      ref="calendar5"
                      @change="onChangeCalendar5"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month5"
                      :navigation="false"
                      :min="new Date(form.year, 4, lastEnableMonth === 5 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 4, 31)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Junio</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 6"
                      ref="calendar6"
                      @change="onChangeCalendar6"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month6"
                      :navigation="false"
                      :min="new Date(form.year, 5, lastEnableMonth === 6 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 5, 30)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Julio</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 7"
                      ref="calendar7"
                      @change="onChangeCalendar7"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month7"
                      :navigation="false"
                      :min="new Date(form.year, 6, lastEnableMonth === 7 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 6, 31)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Agosto</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 8"
                      ref="calendar8"
                      @change="onChangeCalendar8"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month8"
                      :navigation="false"
                      :min="new Date(form.year, 7, lastEnableMonth === 8 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 7, 31)"
                    />
                  </div>
                
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Septiembre</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 9"
                      ref="calendar9"
                      @change="onChangeCalendar9"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month9"
                      :navigation="false"
                      :min="new Date(form.year, 8, lastEnableMonth === 9 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 8, 30)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Octubre</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 10"
                      ref="calendar10"
                      @change="onChangeCalendar10"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month10"
                      :navigation="false"
                      :min="new Date(form.year, 9, lastEnableMonth === 10 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 9, 31)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Noviembre</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 11"
                      ref="calendar11"
                      @change="onChangeCalendar11"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month11"
                      :navigation="false"
                      :min="new Date(form.year, 10, lastEnableMonth === 11 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 10, 30)"
                    />
                  </div>
                  <div class="p-1">
                    <h2 class="dark:text-darkblue-200">Diciembre</h2>
                    <calendar
                      :disabled="disableActionsVacaciones || lastEnableMonth > 12"
                      ref="calendar12"
                      @change="onChangeCalendar12"
                      :mode="'multiple'"
                      :views="1"
                      :focusedDate="focusedDates.month12"
                      :navigation="false"
                      :min="new Date(form.year, 11, lastEnableMonth === 12 ? lastEnableDay : 1)"
                      :max="new Date(form.year, 11, 31)"
                      />
                  </div>
                </div>
              </div>
          </intl>
        </localization>
        </div>
      </div>
      </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <!-- <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="goBack" :loading="isGeneralLoading"/> -->
          <base-button-responsive 
            v-if="isAnyDaySelected && !disableActionsVacaciones && !isLowerThanActualYear" 
            mode="primary" 
            :text="$t('app.solicitar')" 
            icon="plus" 
            @click="validatorSendVacaciones(false)" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/>
          <base-button-responsive 
            v-if="!isPendingAction && !isLowerThanActualYear" 
            mode="primary" 
            :text="$t('app.consult_days_aeat')" 
            icon="check" 
            @click="checkVacaciones()" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"/>
        </template>
      </base-footer>
      <BaseElDialog
        title="Confirmar envío de solicitud"
        :visible.sync="showModalDelete"
        @open="handleOpenModalDialog('container-handleOpenModal-confirm')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n mb-1">{{ processMessageDelete1 }}</span>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDelete2 }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-confirm">
            <base-button class="w-full" @click="showModalDelete = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {sendVacaciones(sendRetryAux); showModalDelete = false}"/>
          </div>
        </template>
      </BaseElDialog>
    </template>
  </detail-layout-full-width>
</template>

<script>
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import Loading from 'vue-loading-overlay'

// import Customcell from '@/components/kendo/calendar/CustomCell.vue'

import { getCompany } from '@/services/companies/getCompany'
import { getDaysCourtesyAEAT } from '@/services/companies/getDaysCourtesyAEAT'
import { sendDaysCourtesyAEAT } from '@/services/companies/sendDaysCourtesyAEAT'
import { checkSendDaysCourtesyAEAT } from '@/services/companies/checkSendDaysCourtesyAEAT'
import { cancelSendDaysCourtesyAEAT } from '@/services/companies/cancelSendDaysCourtesyAEAT' 
import { cancelConsultaDaysCourtesyAEAT } from '@/services/companies/cancelConsultaDaysCourtesyAEAT' 
import { ESTADOS_DIAS_CORTESIA } from '@/config/estados-dias-cortesia'

import { i18n } from '@/i18n'
import { Calendar } from '@progress/kendo-vue-dateinputs'
import { IntlProvider, LocalizationProvider } from '@progress/kendo-vue-intl'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import moment from 'moment'
// import Cell from '../../components/kendo/calendar/Cell.vue'
// import { IntlProvider, loadMessages, LocalizationProvider } from '@progress/kendo-vue-intl'
// import esMessages from './es.json'

// loadMessages(esMessages, 'es-ES')

function getElementByXpath (path) {
  return document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue
}

export default {
  /* eslint-disable camelcase */
  name: 'courtesy-days-aeat-company-detail',
  components: {
    DetailLayoutFullWidth,
    calendar: Calendar,
    localization: LocalizationProvider,
    intl: IntlProvider,
    Loading,
    BaseElDialog,
    // Customcell,
    // custom: Cell,
  },
  data: function () {
    return {
      activeName: 'es',
      header: {
        title: i18n.t('companies.courtesy_days_aeat_header_text'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'companies/detail'
      },
      // Modal
      sendRetryAux: false,
      showModalDelete: false,
      minDaysToSolicitud: 30,
      needConsultaMessage: 'Es necesario tener una consulta realiza con éxito en los últimos 30 días',
      processMessageDelete1: 'Han transcurrido muchos días desde la última consulta correcta.',
      processMessageDelete2: '¿Está seguro que desea solicitar los días sin realizar una consulta previa?',
      loadingCalendar: false,
      customCell: 'myTemplate',
      estadosDiasCortesia: ESTADOS_DIAS_CORTESIA,
      actualYear: new Date().getFullYear(),
      focusedDates: {
        month1: new Date(new Date().getFullYear(), 0, 1),
        month2: new Date(new Date().getFullYear(), 1, 1),
        month3: new Date(new Date().getFullYear(), 2, 1),
        month4: new Date(new Date().getFullYear(), 3, 1),
        month5: new Date(new Date().getFullYear(), 4, 1),
        month6: new Date(new Date().getFullYear(), 5, 1),
        month7: new Date(new Date().getFullYear(), 6, 1),
        month8: new Date(new Date().getFullYear(), 7, 1),
        month9: new Date(new Date().getFullYear(), 8, 1),
        month10: new Date(new Date().getFullYear(), 9, 1),
        month11: new Date(new Date().getFullYear(), 10, 1),
        month12: new Date(new Date().getFullYear(), 11, 1),
      },
      form: {
        year: 1999,
        datesMonth1: [],
        datesMonth2: [],
        datesMonth3: [],
        datesMonth4: [],
        datesMonth5: [],
        datesMonth6: [],
        datesMonth7: [],
        datesMonth8: [],
        datesMonth9: [],
        datesMonth10: [],
        datesMonth11: [],
        datesMonth12: [],
      },
      estadoActual: {
        // Año actual
        dateConsultaOK1: null,
        statusConsulta1: 3,
        dateConsulta1: null,
        dateSolicitudOK1: null,
        statusSolicitud1: 3,
        dateSolicitud1: null,

        totalDays1: 0,
        pendingDays1: 0,
        solicitDays1: 0,
        solicitPending1: 0,

        // Año siguiente
        dateConsultaOK2: null,
        statusConsulta2: 3,
        dateConsulta2: null,
        dateSolicitudOK2: null,
        statusSolicitud2: 3,
        dateSolicitud2: null,

        totalDays2: 0,
        pendingDays2: 0,
        solicitDays2: 0,
        solicitPending2: 0,

        datesAprovados: [],
        datesPending1: [],
        datesPending2: [],
      },
      estadoAnterior: [
        // {
        //   year: 2021,
        //   dateConsultaOK: null,
        //   statusConsulta: 3,
        //   dateConsulta: null,
        //   dateSolicitudOK: null,
        //   statusSolicitud: 3,
        //   dateSolicitud: null,

        //   totalDays: 0,
        //   pendingDays: 0,
        //   solicitDays: 0,
        //   solicitPending: 0,

        //   datesAprovados: [],
        //   datesPending: [],
        // },
      ],
      rules: {
      }
    }
  },
  computed: {
    lastEnableMonth () {
      if (this.isYearActual) return new Date(new Date().setDate(new Date().getDate() + 7)).getMonth() + 1
      return -1
    },
    lastEnableDay () {
      return new Date(new Date().setDate(new Date().getDate() + 7)).getDate() + 1
    },
    esBisiestoActual () {
      return (this.form?.year % 4 === 0 && this.form?.year % 100 !== 0) || (this.form?.year % 400 === 0)
    },
    selectedDateConsultaOK () {
      if (!this.form.year) return null
      if (this.form.year === this.actualYear) return this.estadoActual.dateConsultaOK1
      if (this.form.year > this.actualYear) return this.estadoActual.dateConsultaOK2
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].dateConsultaOK
      else return null
    },
    selectedStatusConsulta () {
      if (!this.form.year) return 3
      if (this.form.year === this.actualYear) return this.estadoActual.statusConsulta1
      if (this.form.year > this.actualYear) return this.estadoActual.statusConsulta2
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].statusConsulta
      else return 3
    },
    selectedDateConsulta () {
      if (!this.form.year) return null
      if (this.form.year === this.actualYear) return this.estadoActual.dateConsulta1
      if (this.form.year > this.actualYear) return this.estadoActual.dateConsulta2
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].dateConsulta
      else return null
    },
    selectedDateSolicitudOK () {
      if (!this.form.year) return null
      if (this.form.year === this.actualYear) return this.estadoActual.dateSolicitudOK1
      if (this.form.year > this.actualYear) return this.estadoActual.dateSolicitudOK2
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].dateSolicitudOK
      else return null
    },
    selectedStatusSolicitud () {
      if (!this.form.year) return 3
      if (this.form.year === this.actualYear) return this.estadoActual.statusSolicitud1
      if (this.form.year > this.actualYear) return this.estadoActual.statusSolicitud2
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].statusSolicitud
      else return 3
    },
    selectedDateSolicitud () {
      if (!this.form.year) return null
      if (this.form.year === this.actualYear) return this.estadoActual.dateSolicitud1
      if (this.form.year > this.actualYear) return this.estadoActual.dateSolicitud2
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].dateSolicitud
      else return null
    },

    selectedTotalDays () {
      if (!this.form.year) return 0
      if (this.form.year === this.actualYear) return this.estadoActual.totalDays1
      if (this.form.year > this.actualYear) return this.estadoActual.totalDays2
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].totalDays
      else return 0
    },
    selectedPendingDays () {
      if (!this.form.year) return 0
      if (this.form.year === this.actualYear) return this.estadoActual.pendingDays1
      if (this.form.year > this.actualYear) return this.estadoActual.pendingDays2
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].pendingDays
      else return 0
    },
    selectedSolicitDays () {
      if (!this.form.year) return 0
      if (this.form.year === this.actualYear) return this.estadoActual.solicitDays1
      if (this.form.year > this.actualYear) return this.estadoActual.solicitDays2
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].solicitDays
      else return 0
    },
    selectedSolicitPending () {
      if (!this.form.year) return 0
      if (this.form.year === this.actualYear) return this.estadoActual.solicitPending1
      if (this.form.year > this.actualYear) return this.estadoActual.solicitPending2
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].solicitPending
      else return 0
    },

    selectedDatesAprobados () {
      if (!this.form.year) return []
      if (this.form.year === this.actualYear || this.form.year > this.actualYear) return this.estadoActual.datesAprovados
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].datesAprovados
      else return []
    },
    selectedDatesPending () {
      if (!this.form.year) return []
      if (this.form.year === this.actualYear) return this.estadoActual.datesPending1
      if (this.form.year > this.actualYear) return this.estadoActual.datesPending2
      const selected = this.estadoAnterior.filter(x => x.year === this.form.year)
      if (selected && selected.length > 0) return selected[0].datesPending
      else return []
    },

    isPendingAction () {
      return this.selectedStatusSolicitud === 0 || this.selectedStatusConsulta === 0
    },
    disableActionsVacaciones () {
      return this.selectedStatusSolicitud === 0 ||
        this.selectedStatusConsulta === 0 ||
        this.selectedStatusSolicitud === 5 ||
        this.isLowerThanActualYear
    },
    statusLabelConsulta () {
      // console.log(this.selectedStatusConsulta)
      return this.estadosDiasCortesia.filter(x => x.id === this.selectedStatusConsulta)[0].name + ' : ' + this.formatDate(this.selectedDateConsulta)
    },
    statusLabelSolicitud () {
      return this.estadosDiasCortesia.filter(x => x.id === this.selectedStatusSolicitud)[0].name + ' : ' + this.formatDate(this.selectedDateSolicitud)
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    idEmpresa () {
      return this.$route.params.id
    },
    totalDaysSelected () {
      const fechas = this.form.datesMonth1
        .concat(this.form.datesMonth2)
        .concat(this.form.datesMonth3)
        .concat(this.form.datesMonth4)
        .concat(this.form.datesMonth5)
        .concat(this.form.datesMonth6)
        .concat(this.form.datesMonth7)
        .concat(this.form.datesMonth8)
        .concat(this.form.datesMonth9)
        .concat(this.form.datesMonth10)
        .concat(this.form.datesMonth11)
        .concat(this.form.datesMonth12)
      return fechas.map(x => this.formatToUTC(x))
    },
    isAnyDaySelected () {
      return this.totalDaysSelected.length > 0
    },
    isYearActual () {
      return this.actualYear === this.form.year
    },
    isLowerThanActualYear () {
      return this.form.year < this.actualYear
    },
    isMoreLowerYear () {
      if (this.form.year > this.actualYear) return true
      return this.estadoAnterior.filter(x => x.year < this.form.year).length > 0
    },
    pendingDaysActual () {
      return this.selectedPendingDays
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.year': function (value, oldValue) {
      this.onChangeYear(value)
    }
  },
  created: async function () {
    // this.form.year = new Date().getFullYear()

    const companyId = this.$route.params.id

    const breadcrumbs = []
    breadcrumbs.push({ path: 'companies', name: this.$i18n.t('app.companies') })
    if (companyId !== -1) {
      if (this.$store.getters['app/fromRouteName'] !== null) {
        const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
        breadcrumbs.push({ path: '', name: breadcrumbHeader })
      } else {
        const company = await this.downloadCompanyData(companyId)
        breadcrumbs.push({ path: '', name: company.NombreCIF })
        this.$store.commit('app/setheaderBreadCrumb', company.NombreCIF)
      }
    }
    this.header.breadcrumb = breadcrumbs

    await this.downloadData()
    this.activateCheckInterval()
  },
  beforeDestroy () {
    this.clearCheckInterval()
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    formatToUTC (date) {
      return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()))
    },
    getDatesBetween (startDate, stopDate) {
      const dateArray = []
      let currentDate = startDate
      while (currentDate <= stopDate) {
        dateArray.push(new Date(currentDate))
        currentDate = new Date(currentDate.setDate(new Date(currentDate).getDate() + 1))
      }
      return dateArray
    },
    markSelected () {
      // Desactivados dias por defecto antiguos
      // if (this.isYearActual) {
      //   const disabledDefault = this.getDatesBetween(new Date(this.actualYear, 0, 1), new Date(new Date().setDate(new Date().getDate() + 7)))
      //   disabledDefault.forEach(x => {
      //     this.markDay(x.getMonth() + 1, x.getDate(), 0)
      //   })
      // }
      // Marcar dias aprobados y pendientes
      this.selectedDatesAprobados.forEach(x => {
        if (x.getFullYear() === this.form.year) {
          this.markDay(x.getMonth() + 1, x.getDate(), 1)
        }
      })
      this.selectedDatesPending.forEach(x => {
        this.markDay(x.getMonth() + 1, x.getDate(), 2)
      })
    },
    // Status: 0 => Deshabilitada, 1 => Aprobada, 2 => Pendiente
    markDay (mes, dia, status) {
      const query = `(//tbody[contains(@class, "k-calendar-tbody")])[${mes}]/tr/td/span[text() = ${dia}]`
      const queryTd = `(//tbody[contains(@class, "k-calendar-tbody")])[${mes}]/tr/td[span[text() = ${dia}]]`
      const spanSelected = getElementByXpath(query)
      const tdSelected = getElementByXpath(queryTd)
      if (status === 0) {
        // tdSelected.setAttribute('style', 'cursor: default!important; opacity: 0.8!important; filter: grayscale(0.1)!important; pointer-events: none!important; box-shadow: none!important;')
      } else if (status === 1) {
        if (this.lastEnableMonth > mes) {
          spanSelected.setAttribute('style', 'background-color: var(--primary-900); color: white !important; border-radius:20px!important')
        } else {
          spanSelected.setAttribute('style', 'background-color: var(--primary-800); color: white !important; border-radius:20px!important')
        }
        tdSelected.setAttribute('style', 'outline: none!important; cursor: default!important; opacity: 0.8!important; filter: grayscale(0.1)!important; pointer-events: none!important; box-shadow: none!important;')
      } else if (status === 2) {
        spanSelected.setAttribute('style', 'background-color: var(--secondary-DEFAULT); color: white !important; ')
        tdSelected.setAttribute('style', 'outline: none!important; cursor: default!important; opacity: 0.8!important; filter: grayscale(0.1)!important; pointer-events: none!important; box-shadow: none!important;')
      }
    },
    onChangeCalendar1 (value) { this.form.datesMonth1 = value.value },
    onChangeCalendar2 (value) { this.form.datesMonth2 = value.value },
    onChangeCalendar3 (value) { this.form.datesMonth3 = value.value },
    onChangeCalendar4 (value) { this.form.datesMonth4 = value.value },
    onChangeCalendar5 (value) { this.form.datesMonth5 = value.value },
    onChangeCalendar6 (value) { this.form.datesMonth6 = value.value },
    onChangeCalendar7 (value) { this.form.datesMonth7 = value.value },
    onChangeCalendar8 (value) { this.form.datesMonth8 = value.value },
    onChangeCalendar9 (value) { this.form.datesMonth9 = value.value },
    onChangeCalendar10 (value) { this.form.datesMonth10 = value.value },
    onChangeCalendar11 (value) { this.form.datesMonth11 = value.value },
    onChangeCalendar12 (value) { this.form.datesMonth12 = value.value },
    modifyYear (add) {
      if (add) this.form.year = this.form.year + 1
      else this.form.year = this.form.year - 1
      if (!this.existYear(this.form.year)) this.modifyYear(add)
      this.activateCheckInterval()
    },
    existYear (year) {
      if (this.actualYear === year || this.actualYear + 1 === year) return true
      if (this.estadoAnterior.filter(x => x.year === year).length > 0) return true
      return false
    },
    onChangeYear (newYear) {
      this.cleanValuesMonths()
      this.loadingCalendar = true
      this.focusedDates.month1.setFullYear(newYear)
      this.focusedDates.month2.setFullYear(newYear)
      this.focusedDates.month3.setFullYear(newYear)
      this.focusedDates.month4.setFullYear(newYear)
      this.focusedDates.month5.setFullYear(newYear)
      this.focusedDates.month6.setFullYear(newYear)
      this.focusedDates.month7.setFullYear(newYear)
      this.focusedDates.month8.setFullYear(newYear)
      this.focusedDates.month9.setFullYear(newYear)
      this.focusedDates.month10.setFullYear(newYear)
      this.focusedDates.month11.setFullYear(newYear)
      this.focusedDates.month12.setFullYear(newYear)
      setTimeout(() => {
        this.loadingCalendar = false
      }, 100)
      setTimeout(() => {
        this.markSelected()
      }, 200)
    },
    cleanValuesMonths () {
      this.form.datesMonth1 = []
      this.form.datesMonth2 = []
      this.form.datesMonth3 = []
      this.form.datesMonth4 = []
      this.form.datesMonth5 = []
      this.form.datesMonth6 = []
      this.form.datesMonth7 = []
      this.form.datesMonth8 = []
      this.form.datesMonth9 = []
      this.form.datesMonth10 = []
      this.form.datesMonth11 = []
      this.form.datesMonth12 = []
    },
    downloadCompanyData: async function (companyId) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { IdCifEmpresa: companyId }
        const company = await getCompany(params)
        return company.CIFSEmpresa[0]
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    watchFormHandler: function ({ certificate, send_alerts, automatic_download, fechaInicioVig }) {
    },
    validatorSendVacaciones (retry) {
      const lastConsultaOK = this.selectedDateConsultaOK
      if (!lastConsultaOK) {
        this.doFeedback(this.needConsultaMessage)
        return
      }
      const difference = new Date().getTime() - lastConsultaOK.getTime()
      const TotalDays = Math.ceil(difference / (1000 * 3600 * 24))
      if (TotalDays >= this.minDaysToSolicitud) {
        this.doFeedback(this.needConsultaMessage)
        return
      } 
      this.sendVacaciones(retry)
    },
    sendVacaciones: async function (retry) {
      if (!retry && this.totalDaysSelected.length > this.pendingDaysActual) {
        this.doFeedback('Se ha generado una solicitud de días y se ha actualizado la información correctamente', 'success')
        // this.doFeedback('Se ha excedido el número de días a solicitar')
        return
      }
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          idCIFEmpresa: this.$route.params.id,
          Fechas: retry 
            ? (this.actualYear === this.form.year 
              ? this.estadoActual.datesPending1.map(x => this.formatToUTC(x))
              : this.estadoActual.datesPending2.map(x => this.formatToUTC(x))) 
            : this.totalDaysSelected,
        }
        const response = await sendDaysCourtesyAEAT(null, payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Se ha generado una solicitud de días y se ha actualizado la información correctamente', 'success')
          this.changeStatusPendiente(false, 0)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    checkVacaciones: async function () {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const response = await checkSendDaysCourtesyAEAT({ idCIFEmpresa: this.$route.params.id, Year: this.form.year })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Se ha generado una consulta correctamente', 'success')
          this.changeStatusPendiente(true, 0)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    cancelVacaciones: async function () {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      try {
        const response = await cancelSendDaysCourtesyAEAT({ idCIFEmpresa: this.$route.params.id, Year: this.form.year })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Se ha cancelado la solicitud y eliminado su respectiva alerta', 'success')
          this.changeStatusPendiente(false, 6, false)
          this.deletePendientes()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    cancelConsultaVacaciones: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await cancelConsultaDaysCourtesyAEAT({ idCIFEmpresa: this.$route.params.id, Year: this.form.year })
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Se ha cancelado la consulta y eliminado su respectiva alerta', 'success')
          this.changeStatusPendiente(true, 6, false)
          // this.deletePendientes()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    deletePendientes () {
      if (this.actualYear === this.form.year) {
        this.estadoActual.solicitPending1 = 0
        this.estadoActual.datesPending1 = []
      } else {
        this.estadoActual.solicitPending2 = 0
        this.estadoActual.datesPending2 = []
      }
      this.loadingCalendar = true
      setTimeout(() => {
        this.loadingCalendar = false
      }, 100)
      setTimeout(() => {
        this.markSelected()
      }, 200)
    },
    changeStatusPendiente (consulta, status, updateDate = true) {
      if (this.actualYear === this.form.year) {
        if (consulta) {
          this.estadoActual.statusConsulta1 = status
          if (updateDate) this.estadoActual.dateConsulta1 = new Date()
        } else {
          this.estadoActual.statusSolicitud1 = status
          if (updateDate) this.estadoActual.dateSolicitud1 = new Date()
        }
      } else {
        if (consulta) {
          this.estadoActual.statusConsulta2 = status
          if (updateDate) this.estadoActual.dateConsulta2 = new Date()
        } else {
          this.estadoActual.statusSolicitud2 = status
          if (updateDate) this.estadoActual.dateSolicitud2 = new Date()
        }
      }
      // Si esta en un estado pendiente activamos intervalo
      this.activateCheckInterval()
      this.$store.dispatch('app/getAnnouncementsList')
    },
    activateCheckInterval () {
      setTimeout(() => {
        this.clearCheckInterval()
        console.log('INIT INTERVAL => check status')
        this.intervalCheck = setInterval(() => {
          console.log('EXEC INTERVAL => check status')
          if (this.isPendingAction) {
            this.downloadData()
          } else {
            this.clearCheckInterval()
          }
        }, 5000)
      }, 2000)
    },
    clearCheckInterval () {
      clearInterval(this.intervalCheck)
      console.log('FINISH INTERVAL => check status')
    },
    downloadData: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const params = { IdCIFEmpresa: this.idEmpresa }
        const response = await getDaysCourtesyAEAT(params)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          this.form.year = new Date().getFullYear()
        } else {
          this.setData(response)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    setData: function (data) {
      if (data) {
        this.loadingCalendar = true
        // Año actual (CurrentYear)
        this.estadoActual.dateConsultaOK1 = data.CurrentYear.UltimaFechaConsultaCorrecta ? new Date(data.CurrentYear.UltimaFechaConsultaCorrecta) : null
        this.estadoActual.statusConsulta1 = data.CurrentYear.idEstadoUltimaConsulta !== null ? data.CurrentYear.idEstadoUltimaConsulta : 3
        this.estadoActual.dateConsulta1 = data.CurrentYear.UltimaFechaConsulta ? new Date(data.CurrentYear.UltimaFechaConsulta) : null
        this.estadoActual.dateSolicitudOK1 = data.CurrentYear.UltimaFechaSolicitudCorrecta ? new Date(data.CurrentYear.UltimaFechaSolicitudCorrecta) : null
        this.estadoActual.statusSolicitud1 = data.CurrentYear.idEstadoUltimaSolicitud !== null ? data.CurrentYear.idEstadoUltimaSolicitud : 3
        this.estadoActual.dateSolicitud1 = data.CurrentYear.UltimaFechaSolicitud ? new Date(data.CurrentYear.UltimaFechaSolicitud) : null

        this.estadoActual.totalDays1 = data.CurrentYear.TotalDias ? data.CurrentYear.TotalDias : 0
        this.estadoActual.solicitDays1 = data.CurrentYear.DiasAprobados ? data.CurrentYear.DiasAprobados : 0
        this.estadoActual.solicitPending1 = data.CurrentYear.DiasPendientes ? data.CurrentYear.DiasPendientes : 0
        this.estadoActual.pendingDays1 = this.estadoActual.totalDays1 - this.estadoActual.solicitDays1 - this.estadoActual.solicitPending1
        this.estadoActual.datesPending1 = data.CurrentYear.FechasPendientes.map(x => new Date(x))

        // Año posterior (NextYear)
        this.estadoActual.dateConsultaOK2 = data.NextYear.UltimaFechaConsultaCorrecta ? new Date(data.NextYear.UltimaFechaConsultaCorrecta) : null
        this.estadoActual.statusConsulta2 = data.NextYear.idEstadoUltimaConsulta !== null ? data.NextYear.idEstadoUltimaConsulta : 3
        this.estadoActual.dateConsulta2 = data.NextYear.UltimaFechaConsulta ? new Date(data.NextYear.UltimaFechaConsulta) : null
        this.estadoActual.dateSolicitudOK2 = data.NextYear.UltimaFechaSolicitudCorrecta ? new Date(data.NextYear.UltimaFechaSolicitudCorrecta) : null
        this.estadoActual.statusSolicitud2 = data.NextYear.idEstadoUltimaSolicitud !== null ? data.NextYear.idEstadoUltimaSolicitud : 3
        this.estadoActual.dateSolicitud2 = data.NextYear.UltimaFechaSolicitud ? new Date(data.NextYear.UltimaFechaSolicitud) : null

        this.estadoActual.totalDays2 = data.NextYear.TotalDias ? data.NextYear.TotalDias : 0
        this.estadoActual.solicitDays2 = data.NextYear.DiasAprobados ? data.NextYear.DiasAprobados : 0
        this.estadoActual.solicitPending2 = data.NextYear.DiasPendientes ? data.NextYear.DiasPendientes : 0
        this.estadoActual.pendingDays2 = this.estadoActual.totalDays2 - this.estadoActual.solicitDays2 - this.estadoActual.solicitPending2
        this.estadoActual.datesPending2 = data.NextYear.FechasPendientes.map(x => new Date(x))

        // Total aprobados
        const fechasAprobadas1 = data.CurrentYear.FechasAprobadas.map(x => new Date(x))
        const fechasAprobadas2 = data.NextYear.FechasAprobadas.map(x => new Date(x))

        this.estadoActual.datesAprovados = fechasAprobadas1.concat(fechasAprobadas2)

        // Historico
        if (data.Historic && data.Historic.length > 0) {
          data.Historic.forEach(historico => {
            const histAux = {
              year: historico.Year,
              dateConsultaOK: historico.TotalDias,
              statusConsulta: historico.idEstadoUltimaConsulta,
              dateConsulta: historico.UltimaFechaConsulta,
              dateSolicitudOK: historico.UltimaFechaConsultaCorrecta,
              statusSolicitud: historico.idEstadoUltimaSolicitud,
              dateSolicitud: historico.UltimaFechaSolicitud,

              totalDays: historico.TotalDias,
              solicitDays: historico.DiasAprobados,
              solicitPending: historico.DiasPendientes,
              pendingDays: historico.TotalDias - historico.DiasAprobados - historico.DiasPendientes,

              datesAprovados: historico.FechasAprobadas.map(x => new Date(x)),
              datesPending: historico.FechasPendientes.map(x => new Date(x)),
            }
            this.estadoAnterior.push(histAux)
          })
        }
      }
      this.form.year = new Date().getFullYear()
      setTimeout(() => {
        this.loadingCalendar = false
        setTimeout(() => {
          this.markSelected()
        }, 200)
      }, 200)
    },
    formatDate: function (strDate) {
      if (!strDate) return 'Ninguna solicitud realizada'
      return moment(strDate).format('DD-MM-yyyy HH:mm')
    },
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
